var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8C6B3"
    },
    d: "M178.834,365.372c-34.354,20.068-60.185,53.125-70.778,92.433 c43.446,25.39,93.992,39.953,147.944,39.953l63.841-68.948L256,365.372H178.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE9276"
    },
    d: "M403.944,457.805c-9.927-36.84-33.241-68.189-64.409-88.5l0,0c-0.001,0-0.001-0.001-0.003-0.001 c-2.088-1.36-4.21-2.671-6.366-3.931H256h-77.166c-1.873,1.094-3.714,2.234-5.535,3.404c-0.277,0.177-0.558,0.349-0.834,0.529l0,0 c-11.279,7.351-21.525,16.153-30.484,26.133c11.817,9.383,24.392,17.422,37.528,23.811c24.371,11.855,49.816,17.92,75.647,18.049 c0.535,2.587,0.845,5.245,0.845,7.957v52.503C309.953,497.758,360.498,483.195,403.944,457.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECCE93"
    },
    d: "M124.811,418.807c-7.302,12.079-12.993,25.241-16.754,39.198 c18.649,10.899,38.61,19.795,59.584,26.409l6.643-16.167C161.826,448.204,144.858,431.263,124.811,418.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1B872"
    },
    d: "M337.716,468.247l6.643,16.167c20.973-6.614,40.934-15.51,59.584-26.408 c-3.762-13.957-9.452-27.12-16.754-39.198C367.143,431.263,350.176,448.204,337.716,468.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE9276"
    },
    d: "M143.318,475.337c10.052,4.183,20.386,7.824,30.967,10.886v-69.049 C158.807,432.828,147.798,452.905,143.318,475.337z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD7155"
    },
    d: "M337.716,417.174v69.049c10.581-3.061,20.914-6.703,30.967-10.886 C364.203,452.905,353.193,432.828,337.716,417.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD7155"
    },
    d: "M256,395.814l-51.073-51.073v77.485c0,9.1,11.002,13.658,17.438,7.223L256,395.814z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BD7155"
    },
    d: "M256,395.814l51.073-51.073v77.485c0,9.1-11.002,13.658-17.438,7.223L256,395.814z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8D472E"
    },
    points: "269.534,388.928 284.983,496.341 255.996,512 243.228,465.082 255.996,388.928 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AB5034"
    },
    points: "242.458,388.928 227.01,496.341 255.996,512 255.996,388.928 "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8D472E"
    },
    cx: 256.003,
    cy: 383.046,
    r: 19.152
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1B872"
    },
    d: "M453.907,146.834c-9.369,0-18.205,2.257-26.019,6.233C409.678,84.188,356.981,21.567,291.266,4.553 L109.401,341.753c1.191,0.772,2.389,1.54,3.624,2.271l0,0c87.771,52.03,198.182,52.03,285.953,0l0,0 c30.992-18.372,48.473-49.687,50.054-82.495c1.609,0.135,3.232,0.221,4.876,0.221c31.733,0,57.457-25.724,57.457-57.457 S485.64,146.834,453.907,146.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECCE93"
    },
    d: "M388.095,192.884c-4.169-10.35-6.782-21.263-7.858-32.369 c-5.863-60.552-40.183-121.071-88.973-155.962c-8.783-2.274-17.796-3.744-26.995-4.294C261.529,0.096,258.773,0,256,0 C174.341,0,105.474,72.227,84.105,153.065c-7.812-3.975-16.646-6.231-26.013-6.231c-31.733,0-57.457,25.724-57.457,57.457 s25.724,57.457,57.457,57.457c1.647,0,3.272-0.086,4.884-0.221c1.525,31.495,17.703,61.613,46.423,80.225 c77.286,27.026,164.184,19.277,235.95-23.265l0,0C389.949,292.048,406.596,238.809,388.095,192.884z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E1B872"
    },
    cx: 58.093,
    cy: 204.291,
    r: 19.152
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5A150"
    },
    cx: 453.91,
    cy: 204.291,
    r: 19.152
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#5B341A",
      enableBackground: "new"
    },
    d: "M94.228,158.199c3.94,2,8.719,1.237,11.844-1.887 c0,0,37.863-37.863,50.484-50.484c0.266-0.266,0.531-0.529,0.798-0.792c11.166-10.991,28.266-12.856,41.882-5.105 c16.743,9.535,36.117,14.982,56.764,14.982s40.021-5.447,56.765-14.981c13.616-7.752,30.715-5.886,41.882,5.105 c0.267,0.263,0.532,0.526,0.797,0.792c12.621,12.621,50.484,50.484,50.484,50.484c3.124,3.124,7.904,3.885,11.844,1.887 l10.123-5.134l0,0C406.526,72.227,337.659,0,256,0S105.474,72.227,84.105,153.065c-1.047-0.532-2.114-1.029-3.197-1.498 c1.09,0.472,2.165,0.973,3.219,1.509L94.228,158.199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#915729",
      enableBackground: "new"
    },
    d: "M109.397,341.753c1.191,0.772,2.389,1.54,3.624,2.271l0,0 c87.771,52.03,198.182,52.03,285.953,0l0,0c30.99-18.371,48.471-49.684,50.054-82.49c-27.343-2.3-49.233-23.741-52.222-50.883 l0.01,0.184c-0.011-0.102-0.015-0.206-0.027-0.308c-0.074-0.686-0.126-1.378-0.176-2.071c-0.024-0.342-0.059-0.682-0.078-1.025 c-0.055-1.02-0.086-2.048-0.087-3.082c0-0.017-0.001-0.033-0.001-0.05l0,0v-0.006c0.18-3.428-1.567-6.752-4.62-8.322 c-7.277-3.744-14.533,1.442-14.533,8.322v0.006l0,0c0,21.158-17.153,38.298-38.311,38.298h-25.53 c-10.577,0-19.152-8.575-19.152-19.152v-0.006c0-10.577-8.574-19.141-19.152-19.141h-38.305c-10.577,0-19.152,8.564-19.152,19.141 v0.005c0,10.577-8.575,19.152-19.152,19.152h-25.53c-21.158,0-38.311-17.14-38.311-38.298l0,0v-0.006 c0.18-3.428-1.567-6.752-4.62-8.322c-7.277-3.744-14.533,8.326-14.533,8.326v0.003c-0.003,30.083-23.13,54.749-52.573,57.23 C64.499,293.023,80.677,323.14,109.397,341.753z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#474641"
    },
    cx: 192.162,
    cy: 204.291,
    r: 19.152
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#474641"
    },
    cx: 319.844,
    cy: 204.291,
    r: 19.152
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M256,252.172c-15.842,0-28.728-12.887-28.728-28.728c0-5.289,4.288-9.576,9.576-9.576 s9.576,4.288,9.576,9.576c0,5.281,4.295,9.576,9.576,9.576c5.281,0,9.576-4.295,9.576-9.576c0-5.289,4.288-9.576,9.576-9.576 c5.289,0,9.576,4.288,9.576,9.576C284.728,239.285,271.842,252.172,256,252.172z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD712C"
    },
    d: "M174.409,159.245c-4.037,0-7.791-2.573-9.105-6.62c-1.634-5.029,1.118-10.432,6.148-12.066 c13.565-4.408,27.888-4.408,41.421-0.001c5.029,1.637,7.778,7.042,6.142,12.07c-1.636,5.029-7.039,7.781-12.07,6.142 c-9.659-3.145-19.885-3.142-29.575,0.005C176.386,159.093,175.389,159.245,174.409,159.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD712C"
    },
    d: "M302.091,159.245c-4.037,0-7.791-2.573-9.105-6.62c-1.634-5.029,1.118-10.432,6.148-12.066 c13.565-4.408,27.888-4.408,41.421-0.001c5.029,1.637,7.778,7.042,6.142,12.07c-1.636,5.029-7.039,7.781-12.07,6.142 c-9.659-3.145-19.885-3.142-29.575,0.005C304.068,159.093,303.071,159.245,302.091,159.245z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.88336a2ff8061f50ef8b3fe9868f3a2c.svg";
export { ForwardRef as ReactComponent };